import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';

const SummaryCard = ({ title, value, icon: Icon, iconColor, iconBgColor, variants }) => {
  return (
    <motion.div variants={variants}>
      <Card
        sx={{
          borderRadius: '4px',
          border: '1px solid #E5E7EB',
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
          height: '100%',
          transition: 'transform 0.2s, box-shadow 0.2s',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <CardContent sx={{ p: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box>
              <Typography
                sx={{
                  fontSize: '0.75rem',
                  color: '#4A5565',
                  fontFamily: 'Inter, sans-serif',
                  mb: 0.5,
                }}
              >
                {title}
              </Typography>
              <Typography
                sx={{
                  fontSize: '1.25rem',
                  fontWeight: 600,
                  color: '#0F172A',
                  fontFamily: 'Inter, sans-serif',
                }}
              >
                {value}
              </Typography>
            </Box>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: '8px',
                bgcolor: iconBgColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Icon sx={{ fontSize: 20, color: iconColor }} />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </motion.div>
  );
};

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.elementType.isRequired,
  iconColor: PropTypes.string.isRequired,
  iconBgColor: PropTypes.string.isRequired,
  variants: PropTypes.object,
};

export default SummaryCard;
